"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var dataUrlToArrayBuffer = function (dataURI) {
    var type = dataURI.match(/:([^}]*);/)[1];
    var byteString = atob(dataURI.split(',')[1]);
    var ia = new Uint8Array(byteString.length);
    for (var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
    }
    return [type, ia.buffer];
};
var canvasToBlob = function (canvas, type) {
    return new Promise(function (resolve) {
        if (canvas.toBlob) {
            canvas.toBlob(function (blob) { return resolve(blob); }, type);
        }
        else {
            var dataURL = canvas.toDataURL(type);
            var _a = dataUrlToArrayBuffer(dataURL), generatedType = _a[0], buffer = _a[1];
            resolve(new Blob([buffer], { type: generatedType }));
        }
    });
};
exports.canvasToBlob = canvasToBlob;
//# sourceMappingURL=saveCanvasHelpers.js.map